
<template>
  <div>
    <!-- <p>HELLOO</p> -->
    <view-by-commission-table v-if="this.$route.name =='Commissions - View By Commissions'"/>
    <view-by-broker-table  v-else-if="this.$route.name =='Commissions - View By Brokers'" />

  </div>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex'
  import ViewByCommissionTable from "../../components/brokerCommission/ViewByCommission.vue";
  import ViewByBrokerTable from "../../components/brokerCommission/ViewByBroker.vue";

  export default {
    data() {
      return {
     
      }
    },
    components : {
      ViewByCommissionTable,
      ViewByBrokerTable
    },
    async created() {
      // this.$vs.loading({ text: 'Loading All Brokers' })
      // await this.loadAllBrokers({
      //   storeName: 'brokers',
      //   url: `admin/brokers`,
      //   commitUrl: 'brokers/SET_BROKERS',
      // })
      // // console.log(this.brokers)
      // this.$vs.loading.close()
    },
    computed: {
      ...mapGetters({
        brokers: 'brokers/brokersList',
        isLoading: 'brokers/isLoading',
        error: 'brokers/error',
      }),
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    methods: {
      ...mapActions({
        loadAllBrokers: 'get',
        deleteBroker: 'delete',
      }),
      errorNotify(){
        this.$vs.notify({color:'danger', title:'Error', text:this.error})
      },
      deleteRow(id) {
        
      },
      editRow(brokerID) {
      }
    },
    watch: {
      isLoading(newValue) {
        if (newValue) {
          this.$vs.loading()
        }else {
          this.$vs.loading.close()
        }
      },
      error(newValue) {
        if (newValue != null) {
          this.errorNotify()
        }
      }
    },
    mounted() {
      this.isMounted = true;
      console.log(this.$route)

    }
  }
</script>

<style>

</style>
